<template>

    <v-section>
        <div id="reviews"></div>
    </v-section>

</template>

<script>

export default {

    mounted() {
        window.saastic('wall', {
            id: 'reviews',
            score: 3,
            avatar: true,
            date: false,
            limit: 100,
            border_color: '#ccc',
            border_width: '1px',
        });
    },

}

</script>